import React from 'react';
import logo from './logo.svg';
import VisualSort from './visualsort/visualsort';
import './App.css';
import ReactDOM from 'react-dom'

function App() {
  return (
    <div className="App">
      <VisualSort></VisualSort>
    </div>
  );
}

export default App;
